var React = require('react');

function Toilet (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M368 0H16A16 16 0 0 0 0 16v16a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16zM136 64H88a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8V72a8 8 0 0 0-8-8z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M352 204.7V48H32v156.7C11.8 214.8 0 226.9 0 240a191.76 191.76 0 0 0 86.8 160.5l-21.4 70.2A32 32 0 0 0 96 512h192a32 32 0 0 0 30.6-41.3l-21.4-70.2A191.76 191.76 0 0 0 384 240c0-13.1-11.8-25.2-32-35.3zM80 72a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H88a8 8 0 0 1-8-8zm112 200c-77.1 0-139.6-14.3-139.6-32s62.5-32 139.6-32 139.6 14.3 139.6 32-62.5 32-139.6 32z","className":"fa-primary","key":2})]);
}

Toilet.defaultProps = {"viewBox":"0 0 384 512","className":"icon"};

module.exports = Toilet;

Toilet.default = Toilet;
